/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAskAiRouteImport } from './routes/_auth/ask-ai'
import { Route as AuthBooksHealthRouteImport } from './routes/_auth/books-health'
import { Route as AuthClassesRouteImport } from './routes/_auth/classes'
import { Route as AuthCompaniesRouteImport } from './routes/_auth/companies'
import { Route as AuthCustomersRouteImport } from './routes/_auth/customers'
import { Route as AuthEmployeesRouteImport } from './routes/_auth/employees'
import { Route as AuthEomFinancialsRouteImport } from './routes/_auth/eom-financials'
import { Route as AuthLocationsRouteImport } from './routes/_auth/locations'
import { Route as AuthPlaidRouteImport } from './routes/_auth/plaid'
import { Route as AuthReallocationsRouteImport } from './routes/_auth/reallocations'
import { Route as AuthSearchRouteImport } from './routes/_auth/search'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthVendorsRouteImport } from './routes/_auth/vendors'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthAccountsIndexRouteImport } from './routes/_auth/accounts.index'
import { Route as AuthAccountsDuplicatesRouteImport } from './routes/_auth/accounts.duplicates'
import { Route as AuthAssistantAttentionRouteImport } from './routes/_auth/assistant.attention'
import { Route as AuthAssistantCalendarRouteImport } from './routes/_auth/assistant.calendar'
import { Route as AuthAssistantConnectionsRouteImport } from './routes/_auth/assistant.connections'
import { Route as AuthAssistantTasksRouteImport } from './routes/_auth/assistant.tasks'
import { Route as AuthAssistantTodayRouteImport } from './routes/_auth/assistant.today'
import { Route as AuthAuditLogIndexRouteImport } from './routes/_auth/audit-log.index'
import { Route as AuthBankIndexRouteImport } from './routes/_auth/bank.index'
import { Route as AuthBankOverviewRouteImport } from './routes/_auth/bank.overview'
import { Route as AuthBankRulesRouteImport } from './routes/_auth/bank.rules'
import { Route as AuthBankTransactionsRouteImport } from './routes/_auth/bank.transactions'
import { Route as AuthBillsIndexRouteImport } from './routes/_auth/bills.index'
import { Route as AuthBillsIdRouteImport } from './routes/_auth/bills.$id'
import { Route as AuthBillsNewRouteImport } from './routes/_auth/bills.new'
import { Route as AuthBudgetIndexRouteImport } from './routes/_auth/budget.index'
import { Route as AuthChecksIndexRouteImport } from './routes/_auth/checks.index'
import { Route as AuthChecksIdRouteImport } from './routes/_auth/checks.$id'
import { Route as AuthChecksNewRouteImport } from './routes/_auth/checks.new'
import { Route as AuthChecksPrintQueueRouteImport } from './routes/_auth/checks.print-queue'
import { Route as AuthCustomerCenterIndexRouteImport } from './routes/_auth/customer-center.index'
import { Route as AuthCustomerCenterIdRouteImport } from './routes/_auth/customer-center.$id'
import { Route as AuthDepositsIndexRouteImport } from './routes/_auth/deposits.index'
import { Route as AuthDepositsIdRouteImport } from './routes/_auth/deposits.$id'
import { Route as AuthDepositsNewRouteImport } from './routes/_auth/deposits.new'
import { Route as AuthDocumentsIndexRouteImport } from './routes/_auth/documents.index'
import { Route as AuthFixedAssetsIndexRouteImport } from './routes/_auth/fixed-assets.index'
import { Route as AuthFixedAssetsIdRouteImport } from './routes/_auth/fixed-assets.$id'
import { Route as AuthFixedAssetsNewRouteImport } from './routes/_auth/fixed-assets.new'
import { Route as AuthImportIndexRouteImport } from './routes/_auth/import.index'
import { Route as AuthIntercompanyIndexRouteImport } from './routes/_auth/intercompany.index'
import { Route as AuthInvoicesIndexRouteImport } from './routes/_auth/invoices.index'
import { Route as AuthInvoicesIdRouteImport } from './routes/_auth/invoices.$id'
import { Route as AuthInvoicesNewRouteImport } from './routes/_auth/invoices.new'
import { Route as AuthJournalIndexRouteImport } from './routes/_auth/journal.index'
import { Route as AuthJournalIdRouteImport } from './routes/_auth/journal.$id'
import { Route as AuthJournalNewRouteImport } from './routes/_auth/journal.new'
import { Route as AuthLoansIndexRouteImport } from './routes/_auth/loans.index'
import { Route as AuthLoansIdRouteImport } from './routes/_auth/loans.$id'
import { Route as AuthLoansNewRouteImport } from './routes/_auth/loans.new'
import { Route as AuthParticipationIndexRouteImport } from './routes/_auth/participation.index'
import { Route as AuthPayrollIndexRouteImport } from './routes/_auth/payroll.index'
import { Route as AuthPayrollIdRouteImport } from './routes/_auth/payroll.$id'
import { Route as AuthPayrollMappingsRouteImport } from './routes/_auth/payroll.mappings'
import { Route as AuthPayrollNewRouteImport } from './routes/_auth/payroll.new'
import { Route as AuthPayrollUncashedRouteImport } from './routes/_auth/payroll.uncashed'
import { Route as AuthReconcileIndexRouteImport } from './routes/_auth/reconcile.index'
import { Route as AuthRecurringIndexRouteImport } from './routes/_auth/recurring.index'
import { Route as AuthRecurringIdRouteImport } from './routes/_auth/recurring.$id'
import { Route as AuthRecurringNewRouteImport } from './routes/_auth/recurring.new'
import { Route as AuthReportBuilderIndexRouteImport } from './routes/_auth/report-builder.index'
import { Route as AuthReportsIndexRouteImport } from './routes/_auth/reports.index'
import { Route as AuthReports1099NecRouteImport } from './routes/_auth/reports.1099-nec'
import { Route as AuthReportsApAgingRouteImport } from './routes/_auth/reports.ap-aging'
import { Route as AuthReportsArAgingRouteImport } from './routes/_auth/reports.ar-aging'
import { Route as AuthReportsBalanceSheetRouteImport } from './routes/_auth/reports.balance-sheet'
import { Route as AuthReportsBudgetVsActualRouteImport } from './routes/_auth/reports.budget-vs-actual'
import { Route as AuthReportsCashFlowRouteImport } from './routes/_auth/reports.cash-flow'
import { Route as AuthReportsCashFlowForecastRouteImport } from './routes/_auth/reports.cash-flow-forecast'
import { Route as AuthReportsDrilldownRouteImport } from './routes/_auth/reports.drilldown'
import { Route as AuthReportsGeneralLedgerRouteImport } from './routes/_auth/reports.general-ledger'
import { Route as AuthReportsIncomeStatementRouteImport } from './routes/_auth/reports.income-statement'
import { Route as AuthReportsSegmentIncomeStatementRouteImport } from './routes/_auth/reports.segment-income-statement'
import { Route as AuthReportsTrialBalanceRouteImport } from './routes/_auth/reports.trial-balance'
import { Route as AuthReportsWeeklyProfitabilityRouteImport } from './routes/_auth/reports.weekly-profitability'
import { Route as AuthSettingsCheckPrintingRouteImport } from './routes/_auth/settings_.check-printing'
import { Route as AuthSettingsParticipationRouteImport } from './routes/_auth/settings_.participation'
import { Route as AuthShareholderLoansIndexRouteImport } from './routes/_auth/shareholder-loans.index'
import { Route as AuthShareholderLoansIdRouteImport } from './routes/_auth/shareholder-loans.$id'
import { Route as AuthShareholderLoansNewRouteImport } from './routes/_auth/shareholder-loans.new'
import { Route as AuthStatementsIndexRouteImport } from './routes/_auth/statements.index'
import { Route as AuthVendorCenterIndexRouteImport } from './routes/_auth/vendor-center.index'
import { Route as AuthVendorCenterIdRouteImport } from './routes/_auth/vendor-center.$id'
import { Route as AuthYearEndIndexRouteImport } from './routes/_auth/year-end.index'
import { Route as AssistantOauthCallbackRouteImport } from './routes/assistant.oauth.callback'
import { Route as AuthBillsIdEditRouteImport } from './routes/_auth/bills.$id_.edit'
import { Route as AuthChecksIdEditRouteImport } from './routes/_auth/checks.$id_.edit'
import { Route as AuthDepositsIdEditRouteImport } from './routes/_auth/deposits.$id_.edit'
import { Route as AuthInvoicesIdEditRouteImport } from './routes/_auth/invoices.$id_.edit'
import { Route as AuthJournalIdEditRouteImport } from './routes/_auth/journal.$id_.edit'
import { Route as AuthPayrollIdEditRouteImport } from './routes/_auth/payroll.$id_.edit'
import { Route as AuthReconcileIdIndexRouteImport } from './routes/_auth/reconcile.$id.index'
import { Route as AuthReconcileIdPreviewRouteImport } from './routes/_auth/reconcile.$id.preview'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAskAiRoute = AuthAskAiRouteImport.update({
  id: '/ask-ai',
  path: '/ask-ai',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBooksHealthRoute = AuthBooksHealthRouteImport.update({
  id: '/books-health',
  path: '/books-health',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClassesRoute = AuthClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompaniesRoute = AuthCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomersRoute = AuthCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmployeesRoute = AuthEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEomFinancialsRoute = AuthEomFinancialsRouteImport.update({
  id: '/eom-financials',
  path: '/eom-financials',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLocationsRoute = AuthLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlaidRoute = AuthPlaidRouteImport.update({
  id: '/plaid',
  path: '/plaid',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReallocationsRoute = AuthReallocationsRouteImport.update({
  id: '/reallocations',
  path: '/reallocations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSearchRoute = AuthSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorsRoute = AuthVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountsIndexRoute = AuthAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountsDuplicatesRoute = AuthAccountsDuplicatesRouteImport.update({
  id: '/accounts/duplicates',
  path: '/accounts/duplicates',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssistantAttentionRoute = AuthAssistantAttentionRouteImport.update({
  id: '/assistant/attention',
  path: '/assistant/attention',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssistantCalendarRoute = AuthAssistantCalendarRouteImport.update({
  id: '/assistant/calendar',
  path: '/assistant/calendar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssistantConnectionsRoute =
  AuthAssistantConnectionsRouteImport.update({
    id: '/assistant/connections',
    path: '/assistant/connections',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAssistantTasksRoute = AuthAssistantTasksRouteImport.update({
  id: '/assistant/tasks',
  path: '/assistant/tasks',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssistantTodayRoute = AuthAssistantTodayRouteImport.update({
  id: '/assistant/today',
  path: '/assistant/today',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditLogIndexRoute = AuthAuditLogIndexRouteImport.update({
  id: '/audit-log/',
  path: '/audit-log/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankIndexRoute = AuthBankIndexRouteImport.update({
  id: '/bank/',
  path: '/bank/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankOverviewRoute = AuthBankOverviewRouteImport.update({
  id: '/bank/overview',
  path: '/bank/overview',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankRulesRoute = AuthBankRulesRouteImport.update({
  id: '/bank/rules',
  path: '/bank/rules',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBankTransactionsRoute = AuthBankTransactionsRouteImport.update({
  id: '/bank/transactions',
  path: '/bank/transactions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillsIndexRoute = AuthBillsIndexRouteImport.update({
  id: '/bills/',
  path: '/bills/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillsIdRoute = AuthBillsIdRouteImport.update({
  id: '/bills/$id',
  path: '/bills/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillsNewRoute = AuthBillsNewRouteImport.update({
  id: '/bills/new',
  path: '/bills/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBudgetIndexRoute = AuthBudgetIndexRouteImport.update({
  id: '/budget/',
  path: '/budget/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChecksIndexRoute = AuthChecksIndexRouteImport.update({
  id: '/checks/',
  path: '/checks/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChecksIdRoute = AuthChecksIdRouteImport.update({
  id: '/checks/$id',
  path: '/checks/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChecksNewRoute = AuthChecksNewRouteImport.update({
  id: '/checks/new',
  path: '/checks/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChecksPrintQueueRoute = AuthChecksPrintQueueRouteImport.update({
  id: '/checks/print-queue',
  path: '/checks/print-queue',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomerCenterIndexRoute = AuthCustomerCenterIndexRouteImport.update({
  id: '/customer-center/',
  path: '/customer-center/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCustomerCenterIdRoute = AuthCustomerCenterIdRouteImport.update({
  id: '/customer-center/$id',
  path: '/customer-center/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDepositsIndexRoute = AuthDepositsIndexRouteImport.update({
  id: '/deposits/',
  path: '/deposits/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDepositsIdRoute = AuthDepositsIdRouteImport.update({
  id: '/deposits/$id',
  path: '/deposits/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDepositsNewRoute = AuthDepositsNewRouteImport.update({
  id: '/deposits/new',
  path: '/deposits/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsIndexRoute = AuthDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFixedAssetsIndexRoute = AuthFixedAssetsIndexRouteImport.update({
  id: '/fixed-assets/',
  path: '/fixed-assets/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFixedAssetsIdRoute = AuthFixedAssetsIdRouteImport.update({
  id: '/fixed-assets/$id',
  path: '/fixed-assets/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFixedAssetsNewRoute = AuthFixedAssetsNewRouteImport.update({
  id: '/fixed-assets/new',
  path: '/fixed-assets/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthImportIndexRoute = AuthImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIntercompanyIndexRoute = AuthIntercompanyIndexRouteImport.update({
  id: '/intercompany/',
  path: '/intercompany/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesIndexRoute = AuthInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesIdRoute = AuthInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesNewRoute = AuthInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalIndexRoute = AuthJournalIndexRouteImport.update({
  id: '/journal/',
  path: '/journal/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalIdRoute = AuthJournalIdRouteImport.update({
  id: '/journal/$id',
  path: '/journal/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalNewRoute = AuthJournalNewRouteImport.update({
  id: '/journal/new',
  path: '/journal/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoansIndexRoute = AuthLoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoansIdRoute = AuthLoansIdRouteImport.update({
  id: '/loans/$id',
  path: '/loans/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoansNewRoute = AuthLoansNewRouteImport.update({
  id: '/loans/new',
  path: '/loans/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthParticipationIndexRoute = AuthParticipationIndexRouteImport.update({
  id: '/participation/',
  path: '/participation/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollIndexRoute = AuthPayrollIndexRouteImport.update({
  id: '/payroll/',
  path: '/payroll/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollIdRoute = AuthPayrollIdRouteImport.update({
  id: '/payroll/$id',
  path: '/payroll/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollMappingsRoute = AuthPayrollMappingsRouteImport.update({
  id: '/payroll/mappings',
  path: '/payroll/mappings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollNewRoute = AuthPayrollNewRouteImport.update({
  id: '/payroll/new',
  path: '/payroll/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollUncashedRoute = AuthPayrollUncashedRouteImport.update({
  id: '/payroll/uncashed',
  path: '/payroll/uncashed',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReconcileIndexRoute = AuthReconcileIndexRouteImport.update({
  id: '/reconcile/',
  path: '/reconcile/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecurringIndexRoute = AuthRecurringIndexRouteImport.update({
  id: '/recurring/',
  path: '/recurring/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecurringIdRoute = AuthRecurringIdRouteImport.update({
  id: '/recurring/$id',
  path: '/recurring/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecurringNewRoute = AuthRecurringNewRouteImport.update({
  id: '/recurring/new',
  path: '/recurring/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportBuilderIndexRoute = AuthReportBuilderIndexRouteImport.update({
  id: '/report-builder/',
  path: '/report-builder/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsIndexRoute = AuthReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReports1099NecRoute = AuthReports1099NecRouteImport.update({
  id: '/reports/1099-nec',
  path: '/reports/1099-nec',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsApAgingRoute = AuthReportsApAgingRouteImport.update({
  id: '/reports/ap-aging',
  path: '/reports/ap-aging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsArAgingRoute = AuthReportsArAgingRouteImport.update({
  id: '/reports/ar-aging',
  path: '/reports/ar-aging',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsBalanceSheetRoute = AuthReportsBalanceSheetRouteImport.update({
  id: '/reports/balance-sheet',
  path: '/reports/balance-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsBudgetVsActualRoute =
  AuthReportsBudgetVsActualRouteImport.update({
    id: '/reports/budget-vs-actual',
    path: '/reports/budget-vs-actual',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsCashFlowRoute = AuthReportsCashFlowRouteImport.update({
  id: '/reports/cash-flow',
  path: '/reports/cash-flow',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsCashFlowForecastRoute =
  AuthReportsCashFlowForecastRouteImport.update({
    id: '/reports/cash-flow-forecast',
    path: '/reports/cash-flow-forecast',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsDrilldownRoute = AuthReportsDrilldownRouteImport.update({
  id: '/reports/drilldown',
  path: '/reports/drilldown',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsGeneralLedgerRoute =
  AuthReportsGeneralLedgerRouteImport.update({
    id: '/reports/general-ledger',
    path: '/reports/general-ledger',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsIncomeStatementRoute =
  AuthReportsIncomeStatementRouteImport.update({
    id: '/reports/income-statement',
    path: '/reports/income-statement',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsSegmentIncomeStatementRoute =
  AuthReportsSegmentIncomeStatementRouteImport.update({
    id: '/reports/segment-income-statement',
    path: '/reports/segment-income-statement',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsTrialBalanceRoute = AuthReportsTrialBalanceRouteImport.update({
  id: '/reports/trial-balance',
  path: '/reports/trial-balance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportsWeeklyProfitabilityRoute =
  AuthReportsWeeklyProfitabilityRouteImport.update({
    id: '/reports/weekly-profitability',
    path: '/reports/weekly-profitability',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsCheckPrintingRoute =
  AuthSettingsCheckPrintingRouteImport.update({
    id: '/settings_/check-printing',
    path: '/settings/check-printing',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsParticipationRoute =
  AuthSettingsParticipationRouteImport.update({
    id: '/settings_/participation',
    path: '/settings/participation',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthShareholderLoansIndexRoute =
  AuthShareholderLoansIndexRouteImport.update({
    id: '/shareholder-loans/',
    path: '/shareholder-loans/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthShareholderLoansIdRoute = AuthShareholderLoansIdRouteImport.update({
  id: '/shareholder-loans/$id',
  path: '/shareholder-loans/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthShareholderLoansNewRoute = AuthShareholderLoansNewRouteImport.update({
  id: '/shareholder-loans/new',
  path: '/shareholder-loans/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStatementsIndexRoute = AuthStatementsIndexRouteImport.update({
  id: '/statements/',
  path: '/statements/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorCenterIndexRoute = AuthVendorCenterIndexRouteImport.update({
  id: '/vendor-center/',
  path: '/vendor-center/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVendorCenterIdRoute = AuthVendorCenterIdRouteImport.update({
  id: '/vendor-center/$id',
  path: '/vendor-center/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthYearEndIndexRoute = AuthYearEndIndexRouteImport.update({
  id: '/year-end/',
  path: '/year-end/',
  getParentRoute: () => AuthRoute,
} as any)
const AssistantOauthCallbackRoute = AssistantOauthCallbackRouteImport.update({
  id: '/assistant/oauth/callback',
  path: '/assistant/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthBillsIdEditRoute = AuthBillsIdEditRouteImport.update({
  id: '/bills/$id_/edit',
  path: '/bills/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChecksIdEditRoute = AuthChecksIdEditRouteImport.update({
  id: '/checks/$id_/edit',
  path: '/checks/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDepositsIdEditRoute = AuthDepositsIdEditRouteImport.update({
  id: '/deposits/$id_/edit',
  path: '/deposits/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvoicesIdEditRoute = AuthInvoicesIdEditRouteImport.update({
  id: '/invoices/$id_/edit',
  path: '/invoices/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJournalIdEditRoute = AuthJournalIdEditRouteImport.update({
  id: '/journal/$id_/edit',
  path: '/journal/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPayrollIdEditRoute = AuthPayrollIdEditRouteImport.update({
  id: '/payroll/$id_/edit',
  path: '/payroll/$id/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReconcileIdIndexRoute = AuthReconcileIdIndexRouteImport.update({
  id: '/reconcile/$id/',
  path: '/reconcile/$id/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReconcileIdPreviewRoute = AuthReconcileIdPreviewRouteImport.update({
  id: '/reconcile/$id/preview',
  path: '/reconcile/$id/preview',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/ask-ai': typeof AuthAskAiRoute
  '/books-health': typeof AuthBooksHealthRoute
  '/classes': typeof AuthClassesRoute
  '/companies': typeof AuthCompaniesRoute
  '/customers': typeof AuthCustomersRoute
  '/employees': typeof AuthEmployeesRoute
  '/eom-financials': typeof AuthEomFinancialsRoute
  '/locations': typeof AuthLocationsRoute
  '/plaid': typeof AuthPlaidRoute
  '/reallocations': typeof AuthReallocationsRoute
  '/search': typeof AuthSearchRoute
  '/settings': typeof AuthSettingsRoute
  '/vendors': typeof AuthVendorsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/accounts/duplicates': typeof AuthAccountsDuplicatesRoute
  '/assistant/attention': typeof AuthAssistantAttentionRoute
  '/assistant/calendar': typeof AuthAssistantCalendarRoute
  '/assistant/connections': typeof AuthAssistantConnectionsRoute
  '/assistant/tasks': typeof AuthAssistantTasksRoute
  '/assistant/today': typeof AuthAssistantTodayRoute
  '/bank/overview': typeof AuthBankOverviewRoute
  '/bank/rules': typeof AuthBankRulesRoute
  '/bank/transactions': typeof AuthBankTransactionsRoute
  '/bills/$id': typeof AuthBillsIdRoute
  '/bills/new': typeof AuthBillsNewRoute
  '/checks/$id': typeof AuthChecksIdRoute
  '/checks/new': typeof AuthChecksNewRoute
  '/checks/print-queue': typeof AuthChecksPrintQueueRoute
  '/customer-center/$id': typeof AuthCustomerCenterIdRoute
  '/deposits/$id': typeof AuthDepositsIdRoute
  '/deposits/new': typeof AuthDepositsNewRoute
  '/fixed-assets/$id': typeof AuthFixedAssetsIdRoute
  '/fixed-assets/new': typeof AuthFixedAssetsNewRoute
  '/invoices/$id': typeof AuthInvoicesIdRoute
  '/invoices/new': typeof AuthInvoicesNewRoute
  '/journal/$id': typeof AuthJournalIdRoute
  '/journal/new': typeof AuthJournalNewRoute
  '/loans/$id': typeof AuthLoansIdRoute
  '/loans/new': typeof AuthLoansNewRoute
  '/payroll/$id': typeof AuthPayrollIdRoute
  '/payroll/mappings': typeof AuthPayrollMappingsRoute
  '/payroll/new': typeof AuthPayrollNewRoute
  '/payroll/uncashed': typeof AuthPayrollUncashedRoute
  '/recurring/$id': typeof AuthRecurringIdRoute
  '/recurring/new': typeof AuthRecurringNewRoute
  '/reports/1099-nec': typeof AuthReports1099NecRoute
  '/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/reports/balance-sheet': typeof AuthReportsBalanceSheetRoute
  '/reports/budget-vs-actual': typeof AuthReportsBudgetVsActualRoute
  '/reports/cash-flow': typeof AuthReportsCashFlowRoute
  '/reports/cash-flow-forecast': typeof AuthReportsCashFlowForecastRoute
  '/reports/drilldown': typeof AuthReportsDrilldownRoute
  '/reports/general-ledger': typeof AuthReportsGeneralLedgerRoute
  '/reports/income-statement': typeof AuthReportsIncomeStatementRoute
  '/reports/segment-income-statement': typeof AuthReportsSegmentIncomeStatementRoute
  '/reports/trial-balance': typeof AuthReportsTrialBalanceRoute
  '/reports/weekly-profitability': typeof AuthReportsWeeklyProfitabilityRoute
  '/settings/check-printing': typeof AuthSettingsCheckPrintingRoute
  '/settings/participation': typeof AuthSettingsParticipationRoute
  '/shareholder-loans/$id': typeof AuthShareholderLoansIdRoute
  '/shareholder-loans/new': typeof AuthShareholderLoansNewRoute
  '/vendor-center/$id': typeof AuthVendorCenterIdRoute
  '/assistant/oauth/callback': typeof AssistantOauthCallbackRoute
  '/accounts/': typeof AuthAccountsIndexRoute
  '/audit-log/': typeof AuthAuditLogIndexRoute
  '/bank/': typeof AuthBankIndexRoute
  '/bills/': typeof AuthBillsIndexRoute
  '/budget/': typeof AuthBudgetIndexRoute
  '/checks/': typeof AuthChecksIndexRoute
  '/customer-center/': typeof AuthCustomerCenterIndexRoute
  '/deposits/': typeof AuthDepositsIndexRoute
  '/documents/': typeof AuthDocumentsIndexRoute
  '/fixed-assets/': typeof AuthFixedAssetsIndexRoute
  '/import/': typeof AuthImportIndexRoute
  '/intercompany/': typeof AuthIntercompanyIndexRoute
  '/invoices/': typeof AuthInvoicesIndexRoute
  '/journal/': typeof AuthJournalIndexRoute
  '/loans/': typeof AuthLoansIndexRoute
  '/participation/': typeof AuthParticipationIndexRoute
  '/payroll/': typeof AuthPayrollIndexRoute
  '/reconcile/': typeof AuthReconcileIndexRoute
  '/recurring/': typeof AuthRecurringIndexRoute
  '/report-builder/': typeof AuthReportBuilderIndexRoute
  '/reports/': typeof AuthReportsIndexRoute
  '/shareholder-loans/': typeof AuthShareholderLoansIndexRoute
  '/statements/': typeof AuthStatementsIndexRoute
  '/vendor-center/': typeof AuthVendorCenterIndexRoute
  '/year-end/': typeof AuthYearEndIndexRoute
  '/bills/$id/edit': typeof AuthBillsIdEditRoute
  '/checks/$id/edit': typeof AuthChecksIdEditRoute
  '/deposits/$id/edit': typeof AuthDepositsIdEditRoute
  '/invoices/$id/edit': typeof AuthInvoicesIdEditRoute
  '/journal/$id/edit': typeof AuthJournalIdEditRoute
  '/payroll/$id/edit': typeof AuthPayrollIdEditRoute
  '/reconcile/$id/preview': typeof AuthReconcileIdPreviewRoute
  '/reconcile/$id/': typeof AuthReconcileIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/ask-ai': typeof AuthAskAiRoute
  '/books-health': typeof AuthBooksHealthRoute
  '/classes': typeof AuthClassesRoute
  '/companies': typeof AuthCompaniesRoute
  '/customers': typeof AuthCustomersRoute
  '/employees': typeof AuthEmployeesRoute
  '/eom-financials': typeof AuthEomFinancialsRoute
  '/locations': typeof AuthLocationsRoute
  '/plaid': typeof AuthPlaidRoute
  '/reallocations': typeof AuthReallocationsRoute
  '/search': typeof AuthSearchRoute
  '/settings': typeof AuthSettingsRoute
  '/vendors': typeof AuthVendorsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthIndexRoute
  '/accounts/duplicates': typeof AuthAccountsDuplicatesRoute
  '/assistant/attention': typeof AuthAssistantAttentionRoute
  '/assistant/calendar': typeof AuthAssistantCalendarRoute
  '/assistant/connections': typeof AuthAssistantConnectionsRoute
  '/assistant/tasks': typeof AuthAssistantTasksRoute
  '/assistant/today': typeof AuthAssistantTodayRoute
  '/bank/overview': typeof AuthBankOverviewRoute
  '/bank/rules': typeof AuthBankRulesRoute
  '/bank/transactions': typeof AuthBankTransactionsRoute
  '/bills/$id': typeof AuthBillsIdRoute
  '/bills/new': typeof AuthBillsNewRoute
  '/checks/$id': typeof AuthChecksIdRoute
  '/checks/new': typeof AuthChecksNewRoute
  '/checks/print-queue': typeof AuthChecksPrintQueueRoute
  '/customer-center/$id': typeof AuthCustomerCenterIdRoute
  '/deposits/$id': typeof AuthDepositsIdRoute
  '/deposits/new': typeof AuthDepositsNewRoute
  '/fixed-assets/$id': typeof AuthFixedAssetsIdRoute
  '/fixed-assets/new': typeof AuthFixedAssetsNewRoute
  '/invoices/$id': typeof AuthInvoicesIdRoute
  '/invoices/new': typeof AuthInvoicesNewRoute
  '/journal/$id': typeof AuthJournalIdRoute
  '/journal/new': typeof AuthJournalNewRoute
  '/loans/$id': typeof AuthLoansIdRoute
  '/loans/new': typeof AuthLoansNewRoute
  '/payroll/$id': typeof AuthPayrollIdRoute
  '/payroll/mappings': typeof AuthPayrollMappingsRoute
  '/payroll/new': typeof AuthPayrollNewRoute
  '/payroll/uncashed': typeof AuthPayrollUncashedRoute
  '/recurring/$id': typeof AuthRecurringIdRoute
  '/recurring/new': typeof AuthRecurringNewRoute
  '/reports/1099-nec': typeof AuthReports1099NecRoute
  '/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/reports/balance-sheet': typeof AuthReportsBalanceSheetRoute
  '/reports/budget-vs-actual': typeof AuthReportsBudgetVsActualRoute
  '/reports/cash-flow': typeof AuthReportsCashFlowRoute
  '/reports/cash-flow-forecast': typeof AuthReportsCashFlowForecastRoute
  '/reports/drilldown': typeof AuthReportsDrilldownRoute
  '/reports/general-ledger': typeof AuthReportsGeneralLedgerRoute
  '/reports/income-statement': typeof AuthReportsIncomeStatementRoute
  '/reports/segment-income-statement': typeof AuthReportsSegmentIncomeStatementRoute
  '/reports/trial-balance': typeof AuthReportsTrialBalanceRoute
  '/reports/weekly-profitability': typeof AuthReportsWeeklyProfitabilityRoute
  '/settings/check-printing': typeof AuthSettingsCheckPrintingRoute
  '/settings/participation': typeof AuthSettingsParticipationRoute
  '/shareholder-loans/$id': typeof AuthShareholderLoansIdRoute
  '/shareholder-loans/new': typeof AuthShareholderLoansNewRoute
  '/vendor-center/$id': typeof AuthVendorCenterIdRoute
  '/assistant/oauth/callback': typeof AssistantOauthCallbackRoute
  '/accounts': typeof AuthAccountsIndexRoute
  '/audit-log': typeof AuthAuditLogIndexRoute
  '/bank': typeof AuthBankIndexRoute
  '/bills': typeof AuthBillsIndexRoute
  '/budget': typeof AuthBudgetIndexRoute
  '/checks': typeof AuthChecksIndexRoute
  '/customer-center': typeof AuthCustomerCenterIndexRoute
  '/deposits': typeof AuthDepositsIndexRoute
  '/documents': typeof AuthDocumentsIndexRoute
  '/fixed-assets': typeof AuthFixedAssetsIndexRoute
  '/import': typeof AuthImportIndexRoute
  '/intercompany': typeof AuthIntercompanyIndexRoute
  '/invoices': typeof AuthInvoicesIndexRoute
  '/journal': typeof AuthJournalIndexRoute
  '/loans': typeof AuthLoansIndexRoute
  '/participation': typeof AuthParticipationIndexRoute
  '/payroll': typeof AuthPayrollIndexRoute
  '/reconcile': typeof AuthReconcileIndexRoute
  '/recurring': typeof AuthRecurringIndexRoute
  '/report-builder': typeof AuthReportBuilderIndexRoute
  '/reports': typeof AuthReportsIndexRoute
  '/shareholder-loans': typeof AuthShareholderLoansIndexRoute
  '/statements': typeof AuthStatementsIndexRoute
  '/vendor-center': typeof AuthVendorCenterIndexRoute
  '/year-end': typeof AuthYearEndIndexRoute
  '/bills/$id/edit': typeof AuthBillsIdEditRoute
  '/checks/$id/edit': typeof AuthChecksIdEditRoute
  '/deposits/$id/edit': typeof AuthDepositsIdEditRoute
  '/invoices/$id/edit': typeof AuthInvoicesIdEditRoute
  '/journal/$id/edit': typeof AuthJournalIdEditRoute
  '/payroll/$id/edit': typeof AuthPayrollIdEditRoute
  '/reconcile/$id/preview': typeof AuthReconcileIdPreviewRoute
  '/reconcile/$id': typeof AuthReconcileIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/_auth/ask-ai': typeof AuthAskAiRoute
  '/_auth/books-health': typeof AuthBooksHealthRoute
  '/_auth/classes': typeof AuthClassesRoute
  '/_auth/companies': typeof AuthCompaniesRoute
  '/_auth/customers': typeof AuthCustomersRoute
  '/_auth/employees': typeof AuthEmployeesRoute
  '/_auth/eom-financials': typeof AuthEomFinancialsRoute
  '/_auth/locations': typeof AuthLocationsRoute
  '/_auth/plaid': typeof AuthPlaidRoute
  '/_auth/reallocations': typeof AuthReallocationsRoute
  '/_auth/search': typeof AuthSearchRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/vendors': typeof AuthVendorsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/accounts/duplicates': typeof AuthAccountsDuplicatesRoute
  '/_auth/assistant/attention': typeof AuthAssistantAttentionRoute
  '/_auth/assistant/calendar': typeof AuthAssistantCalendarRoute
  '/_auth/assistant/connections': typeof AuthAssistantConnectionsRoute
  '/_auth/assistant/tasks': typeof AuthAssistantTasksRoute
  '/_auth/assistant/today': typeof AuthAssistantTodayRoute
  '/_auth/bank/overview': typeof AuthBankOverviewRoute
  '/_auth/bank/rules': typeof AuthBankRulesRoute
  '/_auth/bank/transactions': typeof AuthBankTransactionsRoute
  '/_auth/bills/$id': typeof AuthBillsIdRoute
  '/_auth/bills/new': typeof AuthBillsNewRoute
  '/_auth/checks/$id': typeof AuthChecksIdRoute
  '/_auth/checks/new': typeof AuthChecksNewRoute
  '/_auth/checks/print-queue': typeof AuthChecksPrintQueueRoute
  '/_auth/customer-center/$id': typeof AuthCustomerCenterIdRoute
  '/_auth/deposits/$id': typeof AuthDepositsIdRoute
  '/_auth/deposits/new': typeof AuthDepositsNewRoute
  '/_auth/fixed-assets/$id': typeof AuthFixedAssetsIdRoute
  '/_auth/fixed-assets/new': typeof AuthFixedAssetsNewRoute
  '/_auth/invoices/$id': typeof AuthInvoicesIdRoute
  '/_auth/invoices/new': typeof AuthInvoicesNewRoute
  '/_auth/journal/$id': typeof AuthJournalIdRoute
  '/_auth/journal/new': typeof AuthJournalNewRoute
  '/_auth/loans/$id': typeof AuthLoansIdRoute
  '/_auth/loans/new': typeof AuthLoansNewRoute
  '/_auth/payroll/$id': typeof AuthPayrollIdRoute
  '/_auth/payroll/mappings': typeof AuthPayrollMappingsRoute
  '/_auth/payroll/new': typeof AuthPayrollNewRoute
  '/_auth/payroll/uncashed': typeof AuthPayrollUncashedRoute
  '/_auth/recurring/$id': typeof AuthRecurringIdRoute
  '/_auth/recurring/new': typeof AuthRecurringNewRoute
  '/_auth/reports/1099-nec': typeof AuthReports1099NecRoute
  '/_auth/reports/ap-aging': typeof AuthReportsApAgingRoute
  '/_auth/reports/ar-aging': typeof AuthReportsArAgingRoute
  '/_auth/reports/balance-sheet': typeof AuthReportsBalanceSheetRoute
  '/_auth/reports/budget-vs-actual': typeof AuthReportsBudgetVsActualRoute
  '/_auth/reports/cash-flow': typeof AuthReportsCashFlowRoute
  '/_auth/reports/cash-flow-forecast': typeof AuthReportsCashFlowForecastRoute
  '/_auth/reports/drilldown': typeof AuthReportsDrilldownRoute
  '/_auth/reports/general-ledger': typeof AuthReportsGeneralLedgerRoute
  '/_auth/reports/income-statement': typeof AuthReportsIncomeStatementRoute
  '/_auth/reports/segment-income-statement': typeof AuthReportsSegmentIncomeStatementRoute
  '/_auth/reports/trial-balance': typeof AuthReportsTrialBalanceRoute
  '/_auth/reports/weekly-profitability': typeof AuthReportsWeeklyProfitabilityRoute
  '/_auth/settings_/check-printing': typeof AuthSettingsCheckPrintingRoute
  '/_auth/settings_/participation': typeof AuthSettingsParticipationRoute
  '/_auth/shareholder-loans/$id': typeof AuthShareholderLoansIdRoute
  '/_auth/shareholder-loans/new': typeof AuthShareholderLoansNewRoute
  '/_auth/vendor-center/$id': typeof AuthVendorCenterIdRoute
  '/assistant/oauth/callback': typeof AssistantOauthCallbackRoute
  '/_auth/accounts/': typeof AuthAccountsIndexRoute
  '/_auth/audit-log/': typeof AuthAuditLogIndexRoute
  '/_auth/bank/': typeof AuthBankIndexRoute
  '/_auth/bills/': typeof AuthBillsIndexRoute
  '/_auth/budget/': typeof AuthBudgetIndexRoute
  '/_auth/checks/': typeof AuthChecksIndexRoute
  '/_auth/customer-center/': typeof AuthCustomerCenterIndexRoute
  '/_auth/deposits/': typeof AuthDepositsIndexRoute
  '/_auth/documents/': typeof AuthDocumentsIndexRoute
  '/_auth/fixed-assets/': typeof AuthFixedAssetsIndexRoute
  '/_auth/import/': typeof AuthImportIndexRoute
  '/_auth/intercompany/': typeof AuthIntercompanyIndexRoute
  '/_auth/invoices/': typeof AuthInvoicesIndexRoute
  '/_auth/journal/': typeof AuthJournalIndexRoute
  '/_auth/loans/': typeof AuthLoansIndexRoute
  '/_auth/participation/': typeof AuthParticipationIndexRoute
  '/_auth/payroll/': typeof AuthPayrollIndexRoute
  '/_auth/reconcile/': typeof AuthReconcileIndexRoute
  '/_auth/recurring/': typeof AuthRecurringIndexRoute
  '/_auth/report-builder/': typeof AuthReportBuilderIndexRoute
  '/_auth/reports/': typeof AuthReportsIndexRoute
  '/_auth/shareholder-loans/': typeof AuthShareholderLoansIndexRoute
  '/_auth/statements/': typeof AuthStatementsIndexRoute
  '/_auth/vendor-center/': typeof AuthVendorCenterIndexRoute
  '/_auth/year-end/': typeof AuthYearEndIndexRoute
  '/_auth/bills/$id_/edit': typeof AuthBillsIdEditRoute
  '/_auth/checks/$id_/edit': typeof AuthChecksIdEditRoute
  '/_auth/deposits/$id_/edit': typeof AuthDepositsIdEditRoute
  '/_auth/invoices/$id_/edit': typeof AuthInvoicesIdEditRoute
  '/_auth/journal/$id_/edit': typeof AuthJournalIdEditRoute
  '/_auth/payroll/$id_/edit': typeof AuthPayrollIdEditRoute
  '/_auth/reconcile/$id/preview': typeof AuthReconcileIdPreviewRoute
  '/_auth/reconcile/$id/': typeof AuthReconcileIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy'
    | '/ask-ai'
    | '/books-health'
    | '/classes'
    | '/companies'
    | '/customers'
    | '/employees'
    | '/eom-financials'
    | '/locations'
    | '/plaid'
    | '/reallocations'
    | '/search'
    | '/settings'
    | '/vendors'
    | '/auth/callback'
    | '/accounts/duplicates'
    | '/assistant/attention'
    | '/assistant/calendar'
    | '/assistant/connections'
    | '/assistant/tasks'
    | '/assistant/today'
    | '/bank/overview'
    | '/bank/rules'
    | '/bank/transactions'
    | '/bills/$id'
    | '/bills/new'
    | '/checks/$id'
    | '/checks/new'
    | '/checks/print-queue'
    | '/customer-center/$id'
    | '/deposits/$id'
    | '/deposits/new'
    | '/fixed-assets/$id'
    | '/fixed-assets/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/journal/$id'
    | '/journal/new'
    | '/loans/$id'
    | '/loans/new'
    | '/payroll/$id'
    | '/payroll/mappings'
    | '/payroll/new'
    | '/payroll/uncashed'
    | '/recurring/$id'
    | '/recurring/new'
    | '/reports/1099-nec'
    | '/reports/ap-aging'
    | '/reports/ar-aging'
    | '/reports/balance-sheet'
    | '/reports/budget-vs-actual'
    | '/reports/cash-flow'
    | '/reports/cash-flow-forecast'
    | '/reports/drilldown'
    | '/reports/general-ledger'
    | '/reports/income-statement'
    | '/reports/segment-income-statement'
    | '/reports/trial-balance'
    | '/reports/weekly-profitability'
    | '/settings/check-printing'
    | '/settings/participation'
    | '/shareholder-loans/$id'
    | '/shareholder-loans/new'
    | '/vendor-center/$id'
    | '/assistant/oauth/callback'
    | '/accounts/'
    | '/audit-log/'
    | '/bank/'
    | '/bills/'
    | '/budget/'
    | '/checks/'
    | '/customer-center/'
    | '/deposits/'
    | '/documents/'
    | '/fixed-assets/'
    | '/import/'
    | '/intercompany/'
    | '/invoices/'
    | '/journal/'
    | '/loans/'
    | '/participation/'
    | '/payroll/'
    | '/reconcile/'
    | '/recurring/'
    | '/report-builder/'
    | '/reports/'
    | '/shareholder-loans/'
    | '/statements/'
    | '/vendor-center/'
    | '/year-end/'
    | '/bills/$id/edit'
    | '/checks/$id/edit'
    | '/deposits/$id/edit'
    | '/invoices/$id/edit'
    | '/journal/$id/edit'
    | '/payroll/$id/edit'
    | '/reconcile/$id/preview'
    | '/reconcile/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/privacy'
    | '/ask-ai'
    | '/books-health'
    | '/classes'
    | '/companies'
    | '/customers'
    | '/employees'
    | '/eom-financials'
    | '/locations'
    | '/plaid'
    | '/reallocations'
    | '/search'
    | '/settings'
    | '/vendors'
    | '/auth/callback'
    | '/'
    | '/accounts/duplicates'
    | '/assistant/attention'
    | '/assistant/calendar'
    | '/assistant/connections'
    | '/assistant/tasks'
    | '/assistant/today'
    | '/bank/overview'
    | '/bank/rules'
    | '/bank/transactions'
    | '/bills/$id'
    | '/bills/new'
    | '/checks/$id'
    | '/checks/new'
    | '/checks/print-queue'
    | '/customer-center/$id'
    | '/deposits/$id'
    | '/deposits/new'
    | '/fixed-assets/$id'
    | '/fixed-assets/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/journal/$id'
    | '/journal/new'
    | '/loans/$id'
    | '/loans/new'
    | '/payroll/$id'
    | '/payroll/mappings'
    | '/payroll/new'
    | '/payroll/uncashed'
    | '/recurring/$id'
    | '/recurring/new'
    | '/reports/1099-nec'
    | '/reports/ap-aging'
    | '/reports/ar-aging'
    | '/reports/balance-sheet'
    | '/reports/budget-vs-actual'
    | '/reports/cash-flow'
    | '/reports/cash-flow-forecast'
    | '/reports/drilldown'
    | '/reports/general-ledger'
    | '/reports/income-statement'
    | '/reports/segment-income-statement'
    | '/reports/trial-balance'
    | '/reports/weekly-profitability'
    | '/settings/check-printing'
    | '/settings/participation'
    | '/shareholder-loans/$id'
    | '/shareholder-loans/new'
    | '/vendor-center/$id'
    | '/assistant/oauth/callback'
    | '/accounts'
    | '/audit-log'
    | '/bank'
    | '/bills'
    | '/budget'
    | '/checks'
    | '/customer-center'
    | '/deposits'
    | '/documents'
    | '/fixed-assets'
    | '/import'
    | '/intercompany'
    | '/invoices'
    | '/journal'
    | '/loans'
    | '/participation'
    | '/payroll'
    | '/reconcile'
    | '/recurring'
    | '/report-builder'
    | '/reports'
    | '/shareholder-loans'
    | '/statements'
    | '/vendor-center'
    | '/year-end'
    | '/bills/$id/edit'
    | '/checks/$id/edit'
    | '/deposits/$id/edit'
    | '/invoices/$id/edit'
    | '/journal/$id/edit'
    | '/payroll/$id/edit'
    | '/reconcile/$id/preview'
    | '/reconcile/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/privacy'
    | '/_auth/ask-ai'
    | '/_auth/books-health'
    | '/_auth/classes'
    | '/_auth/companies'
    | '/_auth/customers'
    | '/_auth/employees'
    | '/_auth/eom-financials'
    | '/_auth/locations'
    | '/_auth/plaid'
    | '/_auth/reallocations'
    | '/_auth/search'
    | '/_auth/settings'
    | '/_auth/vendors'
    | '/auth/callback'
    | '/_auth/'
    | '/_auth/accounts/duplicates'
    | '/_auth/assistant/attention'
    | '/_auth/assistant/calendar'
    | '/_auth/assistant/connections'
    | '/_auth/assistant/tasks'
    | '/_auth/assistant/today'
    | '/_auth/bank/overview'
    | '/_auth/bank/rules'
    | '/_auth/bank/transactions'
    | '/_auth/bills/$id'
    | '/_auth/bills/new'
    | '/_auth/checks/$id'
    | '/_auth/checks/new'
    | '/_auth/checks/print-queue'
    | '/_auth/customer-center/$id'
    | '/_auth/deposits/$id'
    | '/_auth/deposits/new'
    | '/_auth/fixed-assets/$id'
    | '/_auth/fixed-assets/new'
    | '/_auth/invoices/$id'
    | '/_auth/invoices/new'
    | '/_auth/journal/$id'
    | '/_auth/journal/new'
    | '/_auth/loans/$id'
    | '/_auth/loans/new'
    | '/_auth/payroll/$id'
    | '/_auth/payroll/mappings'
    | '/_auth/payroll/new'
    | '/_auth/payroll/uncashed'
    | '/_auth/recurring/$id'
    | '/_auth/recurring/new'
    | '/_auth/reports/1099-nec'
    | '/_auth/reports/ap-aging'
    | '/_auth/reports/ar-aging'
    | '/_auth/reports/balance-sheet'
    | '/_auth/reports/budget-vs-actual'
    | '/_auth/reports/cash-flow'
    | '/_auth/reports/cash-flow-forecast'
    | '/_auth/reports/drilldown'
    | '/_auth/reports/general-ledger'
    | '/_auth/reports/income-statement'
    | '/_auth/reports/segment-income-statement'
    | '/_auth/reports/trial-balance'
    | '/_auth/reports/weekly-profitability'
    | '/_auth/settings_/check-printing'
    | '/_auth/settings_/participation'
    | '/_auth/shareholder-loans/$id'
    | '/_auth/shareholder-loans/new'
    | '/_auth/vendor-center/$id'
    | '/assistant/oauth/callback'
    | '/_auth/accounts/'
    | '/_auth/audit-log/'
    | '/_auth/bank/'
    | '/_auth/bills/'
    | '/_auth/budget/'
    | '/_auth/checks/'
    | '/_auth/customer-center/'
    | '/_auth/deposits/'
    | '/_auth/documents/'
    | '/_auth/fixed-assets/'
    | '/_auth/import/'
    | '/_auth/intercompany/'
    | '/_auth/invoices/'
    | '/_auth/journal/'
    | '/_auth/loans/'
    | '/_auth/participation/'
    | '/_auth/payroll/'
    | '/_auth/reconcile/'
    | '/_auth/recurring/'
    | '/_auth/report-builder/'
    | '/_auth/reports/'
    | '/_auth/shareholder-loans/'
    | '/_auth/statements/'
    | '/_auth/vendor-center/'
    | '/_auth/year-end/'
    | '/_auth/bills/$id_/edit'
    | '/_auth/checks/$id_/edit'
    | '/_auth/deposits/$id_/edit'
    | '/_auth/invoices/$id_/edit'
    | '/_auth/journal/$id_/edit'
    | '/_auth/payroll/$id_/edit'
    | '/_auth/reconcile/$id/preview'
    | '/_auth/reconcile/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AssistantOauthCallbackRoute: typeof AssistantOauthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ask-ai': {
      id: '/_auth/ask-ai'
      path: '/ask-ai'
      fullPath: '/ask-ai'
      preLoaderRoute: typeof AuthAskAiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/books-health': {
      id: '/_auth/books-health'
      path: '/books-health'
      fullPath: '/books-health'
      preLoaderRoute: typeof AuthBooksHealthRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/classes': {
      id: '/_auth/classes'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof AuthClassesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/companies': {
      id: '/_auth/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthCompaniesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customers': {
      id: '/_auth/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthCustomersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/employees': {
      id: '/_auth/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/eom-financials': {
      id: '/_auth/eom-financials'
      path: '/eom-financials'
      fullPath: '/eom-financials'
      preLoaderRoute: typeof AuthEomFinancialsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/locations': {
      id: '/_auth/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof AuthLocationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/plaid': {
      id: '/_auth/plaid'
      path: '/plaid'
      fullPath: '/plaid'
      preLoaderRoute: typeof AuthPlaidRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reallocations': {
      id: '/_auth/reallocations'
      path: '/reallocations'
      fullPath: '/reallocations'
      preLoaderRoute: typeof AuthReallocationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/search': {
      id: '/_auth/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthSearchRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendors': {
      id: '/_auth/vendors'
      path: '/vendors'
      fullPath: '/vendors'
      preLoaderRoute: typeof AuthVendorsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/accounts/': {
      id: '/_auth/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthAccountsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounts/duplicates': {
      id: '/_auth/accounts/duplicates'
      path: '/accounts/duplicates'
      fullPath: '/accounts/duplicates'
      preLoaderRoute: typeof AuthAccountsDuplicatesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant/attention': {
      id: '/_auth/assistant/attention'
      path: '/assistant/attention'
      fullPath: '/assistant/attention'
      preLoaderRoute: typeof AuthAssistantAttentionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant/calendar': {
      id: '/_auth/assistant/calendar'
      path: '/assistant/calendar'
      fullPath: '/assistant/calendar'
      preLoaderRoute: typeof AuthAssistantCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant/connections': {
      id: '/_auth/assistant/connections'
      path: '/assistant/connections'
      fullPath: '/assistant/connections'
      preLoaderRoute: typeof AuthAssistantConnectionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant/tasks': {
      id: '/_auth/assistant/tasks'
      path: '/assistant/tasks'
      fullPath: '/assistant/tasks'
      preLoaderRoute: typeof AuthAssistantTasksRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/assistant/today': {
      id: '/_auth/assistant/today'
      path: '/assistant/today'
      fullPath: '/assistant/today'
      preLoaderRoute: typeof AuthAssistantTodayRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit-log/': {
      id: '/_auth/audit-log/'
      path: '/audit-log'
      fullPath: '/audit-log/'
      preLoaderRoute: typeof AuthAuditLogIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank/': {
      id: '/_auth/bank/'
      path: '/bank'
      fullPath: '/bank/'
      preLoaderRoute: typeof AuthBankIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank/overview': {
      id: '/_auth/bank/overview'
      path: '/bank/overview'
      fullPath: '/bank/overview'
      preLoaderRoute: typeof AuthBankOverviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank/rules': {
      id: '/_auth/bank/rules'
      path: '/bank/rules'
      fullPath: '/bank/rules'
      preLoaderRoute: typeof AuthBankRulesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bank/transactions': {
      id: '/_auth/bank/transactions'
      path: '/bank/transactions'
      fullPath: '/bank/transactions'
      preLoaderRoute: typeof AuthBankTransactionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bills/': {
      id: '/_auth/bills/'
      path: '/bills'
      fullPath: '/bills/'
      preLoaderRoute: typeof AuthBillsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bills/$id': {
      id: '/_auth/bills/$id'
      path: '/bills/$id'
      fullPath: '/bills/$id'
      preLoaderRoute: typeof AuthBillsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bills/new': {
      id: '/_auth/bills/new'
      path: '/bills/new'
      fullPath: '/bills/new'
      preLoaderRoute: typeof AuthBillsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budget/': {
      id: '/_auth/budget/'
      path: '/budget'
      fullPath: '/budget/'
      preLoaderRoute: typeof AuthBudgetIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checks/': {
      id: '/_auth/checks/'
      path: '/checks'
      fullPath: '/checks/'
      preLoaderRoute: typeof AuthChecksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checks/$id': {
      id: '/_auth/checks/$id'
      path: '/checks/$id'
      fullPath: '/checks/$id'
      preLoaderRoute: typeof AuthChecksIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checks/new': {
      id: '/_auth/checks/new'
      path: '/checks/new'
      fullPath: '/checks/new'
      preLoaderRoute: typeof AuthChecksNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checks/print-queue': {
      id: '/_auth/checks/print-queue'
      path: '/checks/print-queue'
      fullPath: '/checks/print-queue'
      preLoaderRoute: typeof AuthChecksPrintQueueRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customer-center/': {
      id: '/_auth/customer-center/'
      path: '/customer-center'
      fullPath: '/customer-center/'
      preLoaderRoute: typeof AuthCustomerCenterIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/customer-center/$id': {
      id: '/_auth/customer-center/$id'
      path: '/customer-center/$id'
      fullPath: '/customer-center/$id'
      preLoaderRoute: typeof AuthCustomerCenterIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deposits/': {
      id: '/_auth/deposits/'
      path: '/deposits'
      fullPath: '/deposits/'
      preLoaderRoute: typeof AuthDepositsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deposits/$id': {
      id: '/_auth/deposits/$id'
      path: '/deposits/$id'
      fullPath: '/deposits/$id'
      preLoaderRoute: typeof AuthDepositsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deposits/new': {
      id: '/_auth/deposits/new'
      path: '/deposits/new'
      fullPath: '/deposits/new'
      preLoaderRoute: typeof AuthDepositsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthDocumentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/fixed-assets/': {
      id: '/_auth/fixed-assets/'
      path: '/fixed-assets'
      fullPath: '/fixed-assets/'
      preLoaderRoute: typeof AuthFixedAssetsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/fixed-assets/$id': {
      id: '/_auth/fixed-assets/$id'
      path: '/fixed-assets/$id'
      fullPath: '/fixed-assets/$id'
      preLoaderRoute: typeof AuthFixedAssetsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/fixed-assets/new': {
      id: '/_auth/fixed-assets/new'
      path: '/fixed-assets/new'
      fullPath: '/fixed-assets/new'
      preLoaderRoute: typeof AuthFixedAssetsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/import/': {
      id: '/_auth/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof AuthImportIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/intercompany/': {
      id: '/_auth/intercompany/'
      path: '/intercompany'
      fullPath: '/intercompany/'
      preLoaderRoute: typeof AuthIntercompanyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/': {
      id: '/_auth/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthInvoicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/$id': {
      id: '/_auth/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthInvoicesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/new': {
      id: '/_auth/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthInvoicesNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/': {
      id: '/_auth/journal/'
      path: '/journal'
      fullPath: '/journal/'
      preLoaderRoute: typeof AuthJournalIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/$id': {
      id: '/_auth/journal/$id'
      path: '/journal/$id'
      fullPath: '/journal/$id'
      preLoaderRoute: typeof AuthJournalIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/new': {
      id: '/_auth/journal/new'
      path: '/journal/new'
      fullPath: '/journal/new'
      preLoaderRoute: typeof AuthJournalNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loans/': {
      id: '/_auth/loans/'
      path: '/loans'
      fullPath: '/loans/'
      preLoaderRoute: typeof AuthLoansIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loans/$id': {
      id: '/_auth/loans/$id'
      path: '/loans/$id'
      fullPath: '/loans/$id'
      preLoaderRoute: typeof AuthLoansIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/loans/new': {
      id: '/_auth/loans/new'
      path: '/loans/new'
      fullPath: '/loans/new'
      preLoaderRoute: typeof AuthLoansNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/participation/': {
      id: '/_auth/participation/'
      path: '/participation'
      fullPath: '/participation/'
      preLoaderRoute: typeof AuthParticipationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/': {
      id: '/_auth/payroll/'
      path: '/payroll'
      fullPath: '/payroll/'
      preLoaderRoute: typeof AuthPayrollIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/$id': {
      id: '/_auth/payroll/$id'
      path: '/payroll/$id'
      fullPath: '/payroll/$id'
      preLoaderRoute: typeof AuthPayrollIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/mappings': {
      id: '/_auth/payroll/mappings'
      path: '/payroll/mappings'
      fullPath: '/payroll/mappings'
      preLoaderRoute: typeof AuthPayrollMappingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/new': {
      id: '/_auth/payroll/new'
      path: '/payroll/new'
      fullPath: '/payroll/new'
      preLoaderRoute: typeof AuthPayrollNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/uncashed': {
      id: '/_auth/payroll/uncashed'
      path: '/payroll/uncashed'
      fullPath: '/payroll/uncashed'
      preLoaderRoute: typeof AuthPayrollUncashedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reconcile/': {
      id: '/_auth/reconcile/'
      path: '/reconcile'
      fullPath: '/reconcile/'
      preLoaderRoute: typeof AuthReconcileIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recurring/': {
      id: '/_auth/recurring/'
      path: '/recurring'
      fullPath: '/recurring/'
      preLoaderRoute: typeof AuthRecurringIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recurring/$id': {
      id: '/_auth/recurring/$id'
      path: '/recurring/$id'
      fullPath: '/recurring/$id'
      preLoaderRoute: typeof AuthRecurringIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recurring/new': {
      id: '/_auth/recurring/new'
      path: '/recurring/new'
      fullPath: '/recurring/new'
      preLoaderRoute: typeof AuthRecurringNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/report-builder/': {
      id: '/_auth/report-builder/'
      path: '/report-builder'
      fullPath: '/report-builder/'
      preLoaderRoute: typeof AuthReportBuilderIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/': {
      id: '/_auth/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthReportsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/1099-nec': {
      id: '/_auth/reports/1099-nec'
      path: '/reports/1099-nec'
      fullPath: '/reports/1099-nec'
      preLoaderRoute: typeof AuthReports1099NecRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/ap-aging': {
      id: '/_auth/reports/ap-aging'
      path: '/reports/ap-aging'
      fullPath: '/reports/ap-aging'
      preLoaderRoute: typeof AuthReportsApAgingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/ar-aging': {
      id: '/_auth/reports/ar-aging'
      path: '/reports/ar-aging'
      fullPath: '/reports/ar-aging'
      preLoaderRoute: typeof AuthReportsArAgingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/balance-sheet': {
      id: '/_auth/reports/balance-sheet'
      path: '/reports/balance-sheet'
      fullPath: '/reports/balance-sheet'
      preLoaderRoute: typeof AuthReportsBalanceSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/budget-vs-actual': {
      id: '/_auth/reports/budget-vs-actual'
      path: '/reports/budget-vs-actual'
      fullPath: '/reports/budget-vs-actual'
      preLoaderRoute: typeof AuthReportsBudgetVsActualRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/cash-flow': {
      id: '/_auth/reports/cash-flow'
      path: '/reports/cash-flow'
      fullPath: '/reports/cash-flow'
      preLoaderRoute: typeof AuthReportsCashFlowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/cash-flow-forecast': {
      id: '/_auth/reports/cash-flow-forecast'
      path: '/reports/cash-flow-forecast'
      fullPath: '/reports/cash-flow-forecast'
      preLoaderRoute: typeof AuthReportsCashFlowForecastRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/drilldown': {
      id: '/_auth/reports/drilldown'
      path: '/reports/drilldown'
      fullPath: '/reports/drilldown'
      preLoaderRoute: typeof AuthReportsDrilldownRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/general-ledger': {
      id: '/_auth/reports/general-ledger'
      path: '/reports/general-ledger'
      fullPath: '/reports/general-ledger'
      preLoaderRoute: typeof AuthReportsGeneralLedgerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/income-statement': {
      id: '/_auth/reports/income-statement'
      path: '/reports/income-statement'
      fullPath: '/reports/income-statement'
      preLoaderRoute: typeof AuthReportsIncomeStatementRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/segment-income-statement': {
      id: '/_auth/reports/segment-income-statement'
      path: '/reports/segment-income-statement'
      fullPath: '/reports/segment-income-statement'
      preLoaderRoute: typeof AuthReportsSegmentIncomeStatementRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/trial-balance': {
      id: '/_auth/reports/trial-balance'
      path: '/reports/trial-balance'
      fullPath: '/reports/trial-balance'
      preLoaderRoute: typeof AuthReportsTrialBalanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/weekly-profitability': {
      id: '/_auth/reports/weekly-profitability'
      path: '/reports/weekly-profitability'
      fullPath: '/reports/weekly-profitability'
      preLoaderRoute: typeof AuthReportsWeeklyProfitabilityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings_/check-printing': {
      id: '/_auth/settings_/check-printing'
      path: '/settings/check-printing'
      fullPath: '/settings/check-printing'
      preLoaderRoute: typeof AuthSettingsCheckPrintingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings_/participation': {
      id: '/_auth/settings_/participation'
      path: '/settings/participation'
      fullPath: '/settings/participation'
      preLoaderRoute: typeof AuthSettingsParticipationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/shareholder-loans/': {
      id: '/_auth/shareholder-loans/'
      path: '/shareholder-loans'
      fullPath: '/shareholder-loans/'
      preLoaderRoute: typeof AuthShareholderLoansIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/shareholder-loans/$id': {
      id: '/_auth/shareholder-loans/$id'
      path: '/shareholder-loans/$id'
      fullPath: '/shareholder-loans/$id'
      preLoaderRoute: typeof AuthShareholderLoansIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/shareholder-loans/new': {
      id: '/_auth/shareholder-loans/new'
      path: '/shareholder-loans/new'
      fullPath: '/shareholder-loans/new'
      preLoaderRoute: typeof AuthShareholderLoansNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/statements/': {
      id: '/_auth/statements/'
      path: '/statements'
      fullPath: '/statements/'
      preLoaderRoute: typeof AuthStatementsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendor-center/': {
      id: '/_auth/vendor-center/'
      path: '/vendor-center'
      fullPath: '/vendor-center/'
      preLoaderRoute: typeof AuthVendorCenterIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/vendor-center/$id': {
      id: '/_auth/vendor-center/$id'
      path: '/vendor-center/$id'
      fullPath: '/vendor-center/$id'
      preLoaderRoute: typeof AuthVendorCenterIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/year-end/': {
      id: '/_auth/year-end/'
      path: '/year-end'
      fullPath: '/year-end/'
      preLoaderRoute: typeof AuthYearEndIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/assistant/oauth/callback': {
      id: '/assistant/oauth/callback'
      path: '/assistant/oauth/callback'
      fullPath: '/assistant/oauth/callback'
      preLoaderRoute: typeof AssistantOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/bills/$id_/edit': {
      id: '/_auth/bills/$id_/edit'
      path: '/bills/$id/edit'
      fullPath: '/bills/$id/edit'
      preLoaderRoute: typeof AuthBillsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/checks/$id_/edit': {
      id: '/_auth/checks/$id_/edit'
      path: '/checks/$id/edit'
      fullPath: '/checks/$id/edit'
      preLoaderRoute: typeof AuthChecksIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deposits/$id_/edit': {
      id: '/_auth/deposits/$id_/edit'
      path: '/deposits/$id/edit'
      fullPath: '/deposits/$id/edit'
      preLoaderRoute: typeof AuthDepositsIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invoices/$id_/edit': {
      id: '/_auth/invoices/$id_/edit'
      path: '/invoices/$id/edit'
      fullPath: '/invoices/$id/edit'
      preLoaderRoute: typeof AuthInvoicesIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/journal/$id_/edit': {
      id: '/_auth/journal/$id_/edit'
      path: '/journal/$id/edit'
      fullPath: '/journal/$id/edit'
      preLoaderRoute: typeof AuthJournalIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payroll/$id_/edit': {
      id: '/_auth/payroll/$id_/edit'
      path: '/payroll/$id/edit'
      fullPath: '/payroll/$id/edit'
      preLoaderRoute: typeof AuthPayrollIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reconcile/$id/': {
      id: '/_auth/reconcile/$id/'
      path: '/reconcile/$id'
      fullPath: '/reconcile/$id/'
      preLoaderRoute: typeof AuthReconcileIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reconcile/$id/preview': {
      id: '/_auth/reconcile/$id/preview'
      path: '/reconcile/$id/preview'
      fullPath: '/reconcile/$id/preview'
      preLoaderRoute: typeof AuthReconcileIdPreviewRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAskAiRoute: typeof AuthAskAiRoute
  AuthBooksHealthRoute: typeof AuthBooksHealthRoute
  AuthClassesRoute: typeof AuthClassesRoute
  AuthCompaniesRoute: typeof AuthCompaniesRoute
  AuthCustomersRoute: typeof AuthCustomersRoute
  AuthEmployeesRoute: typeof AuthEmployeesRoute
  AuthEomFinancialsRoute: typeof AuthEomFinancialsRoute
  AuthLocationsRoute: typeof AuthLocationsRoute
  AuthPlaidRoute: typeof AuthPlaidRoute
  AuthReallocationsRoute: typeof AuthReallocationsRoute
  AuthSearchRoute: typeof AuthSearchRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthVendorsRoute: typeof AuthVendorsRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAccountsDuplicatesRoute: typeof AuthAccountsDuplicatesRoute
  AuthAssistantAttentionRoute: typeof AuthAssistantAttentionRoute
  AuthAssistantCalendarRoute: typeof AuthAssistantCalendarRoute
  AuthAssistantConnectionsRoute: typeof AuthAssistantConnectionsRoute
  AuthAssistantTasksRoute: typeof AuthAssistantTasksRoute
  AuthAssistantTodayRoute: typeof AuthAssistantTodayRoute
  AuthBankOverviewRoute: typeof AuthBankOverviewRoute
  AuthBankRulesRoute: typeof AuthBankRulesRoute
  AuthBankTransactionsRoute: typeof AuthBankTransactionsRoute
  AuthBillsIdRoute: typeof AuthBillsIdRoute
  AuthBillsNewRoute: typeof AuthBillsNewRoute
  AuthChecksIdRoute: typeof AuthChecksIdRoute
  AuthChecksNewRoute: typeof AuthChecksNewRoute
  AuthChecksPrintQueueRoute: typeof AuthChecksPrintQueueRoute
  AuthCustomerCenterIdRoute: typeof AuthCustomerCenterIdRoute
  AuthDepositsIdRoute: typeof AuthDepositsIdRoute
  AuthDepositsNewRoute: typeof AuthDepositsNewRoute
  AuthFixedAssetsIdRoute: typeof AuthFixedAssetsIdRoute
  AuthFixedAssetsNewRoute: typeof AuthFixedAssetsNewRoute
  AuthInvoicesIdRoute: typeof AuthInvoicesIdRoute
  AuthInvoicesNewRoute: typeof AuthInvoicesNewRoute
  AuthJournalIdRoute: typeof AuthJournalIdRoute
  AuthJournalNewRoute: typeof AuthJournalNewRoute
  AuthLoansIdRoute: typeof AuthLoansIdRoute
  AuthLoansNewRoute: typeof AuthLoansNewRoute
  AuthPayrollIdRoute: typeof AuthPayrollIdRoute
  AuthPayrollMappingsRoute: typeof AuthPayrollMappingsRoute
  AuthPayrollNewRoute: typeof AuthPayrollNewRoute
  AuthPayrollUncashedRoute: typeof AuthPayrollUncashedRoute
  AuthRecurringIdRoute: typeof AuthRecurringIdRoute
  AuthRecurringNewRoute: typeof AuthRecurringNewRoute
  AuthReports1099NecRoute: typeof AuthReports1099NecRoute
  AuthReportsApAgingRoute: typeof AuthReportsApAgingRoute
  AuthReportsArAgingRoute: typeof AuthReportsArAgingRoute
  AuthReportsBalanceSheetRoute: typeof AuthReportsBalanceSheetRoute
  AuthReportsBudgetVsActualRoute: typeof AuthReportsBudgetVsActualRoute
  AuthReportsCashFlowRoute: typeof AuthReportsCashFlowRoute
  AuthReportsCashFlowForecastRoute: typeof AuthReportsCashFlowForecastRoute
  AuthReportsDrilldownRoute: typeof AuthReportsDrilldownRoute
  AuthReportsGeneralLedgerRoute: typeof AuthReportsGeneralLedgerRoute
  AuthReportsIncomeStatementRoute: typeof AuthReportsIncomeStatementRoute
  AuthReportsSegmentIncomeStatementRoute: typeof AuthReportsSegmentIncomeStatementRoute
  AuthReportsTrialBalanceRoute: typeof AuthReportsTrialBalanceRoute
  AuthReportsWeeklyProfitabilityRoute: typeof AuthReportsWeeklyProfitabilityRoute
  AuthSettingsCheckPrintingRoute: typeof AuthSettingsCheckPrintingRoute
  AuthSettingsParticipationRoute: typeof AuthSettingsParticipationRoute
  AuthShareholderLoansIdRoute: typeof AuthShareholderLoansIdRoute
  AuthShareholderLoansNewRoute: typeof AuthShareholderLoansNewRoute
  AuthVendorCenterIdRoute: typeof AuthVendorCenterIdRoute
  AuthAccountsIndexRoute: typeof AuthAccountsIndexRoute
  AuthAuditLogIndexRoute: typeof AuthAuditLogIndexRoute
  AuthBankIndexRoute: typeof AuthBankIndexRoute
  AuthBillsIndexRoute: typeof AuthBillsIndexRoute
  AuthBudgetIndexRoute: typeof AuthBudgetIndexRoute
  AuthChecksIndexRoute: typeof AuthChecksIndexRoute
  AuthCustomerCenterIndexRoute: typeof AuthCustomerCenterIndexRoute
  AuthDepositsIndexRoute: typeof AuthDepositsIndexRoute
  AuthDocumentsIndexRoute: typeof AuthDocumentsIndexRoute
  AuthFixedAssetsIndexRoute: typeof AuthFixedAssetsIndexRoute
  AuthImportIndexRoute: typeof AuthImportIndexRoute
  AuthIntercompanyIndexRoute: typeof AuthIntercompanyIndexRoute
  AuthInvoicesIndexRoute: typeof AuthInvoicesIndexRoute
  AuthJournalIndexRoute: typeof AuthJournalIndexRoute
  AuthLoansIndexRoute: typeof AuthLoansIndexRoute
  AuthParticipationIndexRoute: typeof AuthParticipationIndexRoute
  AuthPayrollIndexRoute: typeof AuthPayrollIndexRoute
  AuthReconcileIndexRoute: typeof AuthReconcileIndexRoute
  AuthRecurringIndexRoute: typeof AuthRecurringIndexRoute
  AuthReportBuilderIndexRoute: typeof AuthReportBuilderIndexRoute
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute
  AuthShareholderLoansIndexRoute: typeof AuthShareholderLoansIndexRoute
  AuthStatementsIndexRoute: typeof AuthStatementsIndexRoute
  AuthVendorCenterIndexRoute: typeof AuthVendorCenterIndexRoute
  AuthYearEndIndexRoute: typeof AuthYearEndIndexRoute
  AuthBillsIdEditRoute: typeof AuthBillsIdEditRoute
  AuthChecksIdEditRoute: typeof AuthChecksIdEditRoute
  AuthDepositsIdEditRoute: typeof AuthDepositsIdEditRoute
  AuthInvoicesIdEditRoute: typeof AuthInvoicesIdEditRoute
  AuthJournalIdEditRoute: typeof AuthJournalIdEditRoute
  AuthPayrollIdEditRoute: typeof AuthPayrollIdEditRoute
  AuthReconcileIdPreviewRoute: typeof AuthReconcileIdPreviewRoute
  AuthReconcileIdIndexRoute: typeof AuthReconcileIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAskAiRoute: AuthAskAiRoute,
  AuthBooksHealthRoute: AuthBooksHealthRoute,
  AuthClassesRoute: AuthClassesRoute,
  AuthCompaniesRoute: AuthCompaniesRoute,
  AuthCustomersRoute: AuthCustomersRoute,
  AuthEmployeesRoute: AuthEmployeesRoute,
  AuthEomFinancialsRoute: AuthEomFinancialsRoute,
  AuthLocationsRoute: AuthLocationsRoute,
  AuthPlaidRoute: AuthPlaidRoute,
  AuthReallocationsRoute: AuthReallocationsRoute,
  AuthSearchRoute: AuthSearchRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthVendorsRoute: AuthVendorsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAccountsDuplicatesRoute: AuthAccountsDuplicatesRoute,
  AuthAssistantAttentionRoute: AuthAssistantAttentionRoute,
  AuthAssistantCalendarRoute: AuthAssistantCalendarRoute,
  AuthAssistantConnectionsRoute: AuthAssistantConnectionsRoute,
  AuthAssistantTasksRoute: AuthAssistantTasksRoute,
  AuthAssistantTodayRoute: AuthAssistantTodayRoute,
  AuthBankOverviewRoute: AuthBankOverviewRoute,
  AuthBankRulesRoute: AuthBankRulesRoute,
  AuthBankTransactionsRoute: AuthBankTransactionsRoute,
  AuthBillsIdRoute: AuthBillsIdRoute,
  AuthBillsNewRoute: AuthBillsNewRoute,
  AuthChecksIdRoute: AuthChecksIdRoute,
  AuthChecksNewRoute: AuthChecksNewRoute,
  AuthChecksPrintQueueRoute: AuthChecksPrintQueueRoute,
  AuthCustomerCenterIdRoute: AuthCustomerCenterIdRoute,
  AuthDepositsIdRoute: AuthDepositsIdRoute,
  AuthDepositsNewRoute: AuthDepositsNewRoute,
  AuthFixedAssetsIdRoute: AuthFixedAssetsIdRoute,
  AuthFixedAssetsNewRoute: AuthFixedAssetsNewRoute,
  AuthInvoicesIdRoute: AuthInvoicesIdRoute,
  AuthInvoicesNewRoute: AuthInvoicesNewRoute,
  AuthJournalIdRoute: AuthJournalIdRoute,
  AuthJournalNewRoute: AuthJournalNewRoute,
  AuthLoansIdRoute: AuthLoansIdRoute,
  AuthLoansNewRoute: AuthLoansNewRoute,
  AuthPayrollIdRoute: AuthPayrollIdRoute,
  AuthPayrollMappingsRoute: AuthPayrollMappingsRoute,
  AuthPayrollNewRoute: AuthPayrollNewRoute,
  AuthPayrollUncashedRoute: AuthPayrollUncashedRoute,
  AuthRecurringIdRoute: AuthRecurringIdRoute,
  AuthRecurringNewRoute: AuthRecurringNewRoute,
  AuthReports1099NecRoute: AuthReports1099NecRoute,
  AuthReportsApAgingRoute: AuthReportsApAgingRoute,
  AuthReportsArAgingRoute: AuthReportsArAgingRoute,
  AuthReportsBalanceSheetRoute: AuthReportsBalanceSheetRoute,
  AuthReportsBudgetVsActualRoute: AuthReportsBudgetVsActualRoute,
  AuthReportsCashFlowRoute: AuthReportsCashFlowRoute,
  AuthReportsCashFlowForecastRoute: AuthReportsCashFlowForecastRoute,
  AuthReportsDrilldownRoute: AuthReportsDrilldownRoute,
  AuthReportsGeneralLedgerRoute: AuthReportsGeneralLedgerRoute,
  AuthReportsIncomeStatementRoute: AuthReportsIncomeStatementRoute,
  AuthReportsSegmentIncomeStatementRoute:
    AuthReportsSegmentIncomeStatementRoute,
  AuthReportsTrialBalanceRoute: AuthReportsTrialBalanceRoute,
  AuthReportsWeeklyProfitabilityRoute: AuthReportsWeeklyProfitabilityRoute,
  AuthSettingsCheckPrintingRoute: AuthSettingsCheckPrintingRoute,
  AuthSettingsParticipationRoute: AuthSettingsParticipationRoute,
  AuthShareholderLoansIdRoute: AuthShareholderLoansIdRoute,
  AuthShareholderLoansNewRoute: AuthShareholderLoansNewRoute,
  AuthVendorCenterIdRoute: AuthVendorCenterIdRoute,
  AuthAccountsIndexRoute: AuthAccountsIndexRoute,
  AuthAuditLogIndexRoute: AuthAuditLogIndexRoute,
  AuthBankIndexRoute: AuthBankIndexRoute,
  AuthBillsIndexRoute: AuthBillsIndexRoute,
  AuthBudgetIndexRoute: AuthBudgetIndexRoute,
  AuthChecksIndexRoute: AuthChecksIndexRoute,
  AuthCustomerCenterIndexRoute: AuthCustomerCenterIndexRoute,
  AuthDepositsIndexRoute: AuthDepositsIndexRoute,
  AuthDocumentsIndexRoute: AuthDocumentsIndexRoute,
  AuthFixedAssetsIndexRoute: AuthFixedAssetsIndexRoute,
  AuthImportIndexRoute: AuthImportIndexRoute,
  AuthIntercompanyIndexRoute: AuthIntercompanyIndexRoute,
  AuthInvoicesIndexRoute: AuthInvoicesIndexRoute,
  AuthJournalIndexRoute: AuthJournalIndexRoute,
  AuthLoansIndexRoute: AuthLoansIndexRoute,
  AuthParticipationIndexRoute: AuthParticipationIndexRoute,
  AuthPayrollIndexRoute: AuthPayrollIndexRoute,
  AuthReconcileIndexRoute: AuthReconcileIndexRoute,
  AuthRecurringIndexRoute: AuthRecurringIndexRoute,
  AuthReportBuilderIndexRoute: AuthReportBuilderIndexRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
  AuthShareholderLoansIndexRoute: AuthShareholderLoansIndexRoute,
  AuthStatementsIndexRoute: AuthStatementsIndexRoute,
  AuthVendorCenterIndexRoute: AuthVendorCenterIndexRoute,
  AuthYearEndIndexRoute: AuthYearEndIndexRoute,
  AuthBillsIdEditRoute: AuthBillsIdEditRoute,
  AuthChecksIdEditRoute: AuthChecksIdEditRoute,
  AuthDepositsIdEditRoute: AuthDepositsIdEditRoute,
  AuthInvoicesIdEditRoute: AuthInvoicesIdEditRoute,
  AuthJournalIdEditRoute: AuthJournalIdEditRoute,
  AuthPayrollIdEditRoute: AuthPayrollIdEditRoute,
  AuthReconcileIdPreviewRoute: AuthReconcileIdPreviewRoute,
  AuthReconcileIdIndexRoute: AuthReconcileIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AssistantOauthCallbackRoute: AssistantOauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
